import { catalogApiFetch, apiFetch, getAdminAuthToken } from '../admin/jscontrol/apiClient';
import { parseApiList } from './productStorefront';

export const parseSettingList = (body) => {
  if (!body) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.data)) return body.data;
  if (body?.data && Array.isArray(body.data.data)) return body.data.data;
  return parseApiList(body);
};

/** Map setting Name → Value (case-insensitive keys stored as given). */
export const mapSettingsByName = (items) => {
  const map = {};
  items.forEach((row) => {
    const name = String(row?.Name ?? row?.name ?? '').trim();
    if (!name) return;
    map[name] = String(row?.Value ?? row?.value ?? '');
  });
  return map;
};

export const getSettingValue = (settingsMap, name, fallback = '') => {
  if (!settingsMap || !name) return fallback;
  const exact = settingsMap[name];
  if (exact !== undefined) return exact;
  const key = Object.keys(settingsMap).find(
    (k) => k.toLowerCase() === String(name).toLowerCase()
  );
  return key !== undefined ? settingsMap[key] : fallback;
};

export async function fetchSettingsMap() {
  const params = new URLSearchParams({
    pageIndex: '1',
    pageSize: '500',
    search: '',
    sortColumn: 'Name',
    sortBy: 'ASC',
  });
  const endpoint = `/Setting/GetAll?${params}`;

  const loadMap = async (fetcher) => {
    const { data } = await fetcher(endpoint);
    return mapSettingsByName(parseSettingList(data));
  };

  if (getAdminAuthToken()) {
    try {
      return await loadMap(apiFetch);
    } catch {
      /* try catalog read below */
    }
  }

  try {
    return await loadMap(catalogApiFetch);
  } catch {
    return {};
  }
}

export const formatPriceWithSymbol = (amount, symbol = '$', decimals = 2) => {
  const n = Number(amount);
  if (Number.isNaN(n)) return `${symbol}${(0).toFixed(decimals)}`;
  return `${symbol}${n.toFixed(decimals)}`;
};
